import {
    createPlan, CreatePlanParams, updatePlan, UpdatePlanParams,
} from '@/api/email/emailMarketing';
import { getField, updateField } from '@/libs/vuexHelper';
import shtml from '@/views/main/authMode/Chat/helper/xss';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';

const PlanForm = {
    name: '',
    email_title: '',
    email_content: '',
    template_content: '',
    template_id: '',
    begin_config: '0',
    begin_time: '',
    timezone: '',
    email: '',
    email_test: '',
    sender_name: '',
    label_ids: '',
};
export interface IForm {
    sender_name: string;
    name: string;
    email_title: string;
    email_content: string;
    template_content: string;
    template_id: string;
    begin_config: '0' | '1';
    begin_time: Date | string,
    timezone: string;
    email: string;
    email_test: string;
    label_ids: string;
    exclude_chat_user_ids?: string;
    advanced_query_type?: string;
    advanced_query?: string;
}

interface IState {
    planForm: IForm;
    audience: number;
}

export default {
    namespaced: true,
    state: {
        currentStep: 0,
        planForm: cloneDeep(PlanForm),
        audience: 0,
        templateUrl: {
            html: '',
            css: '',
        }, //  使用的邮件模板url
        openPreview: false,
        pluginloading: true,
        codeEditorOpen: false,
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        resetPlanForm(state: IState) {
            state.planForm = cloneDeep(PlanForm as IForm);
            state.audience = 0;
        },
    },
    actions: {
        updatePlan({ state }: any, { id, is_draft = '0' }: { id: string, is_draft: '0' | '1' }) {
            let begin_time;
            if (is_draft === '1' && state.planForm.begin_config === '1' && !state.planForm.begin_time) {
                // 保存草稿 且定时，又没选时间，则存当前时间
                begin_time = dayjs().format('YYYY-MM-DD HH:mm:00');
            } else {
                begin_time = state.planForm.begin_config === '1' ? dayjs(state.planForm.begin_time).format(
                    'YYYY-MM-DD HH:mm:00',
                ) : '';
            }
            const params: UpdatePlanParams = {
                ...state.planForm,
                name: state.planForm.name,
                email_title: state.planForm.email_title,
                email_content: shtml(state.planForm.email_content),
                begin_config: state.planForm.begin_config,
                begin_time,
                timezone: state.planForm.timezone || '',
                sender_name: state.planForm.sender_name,
                email: state.planForm.email,
                template_content: state.planForm.template_content,
                template_id: state.planForm.template_id,
                id,
                is_draft,
            };
            if (params.begin_config === '0') {
                params.begin_time = '';
                params.timezone = '';
            }
            return updatePlan(params);
        },
        createPlan({ state }: any, { is_draft = '0' }: { is_draft: '0' | '1' }) {
            let begin_time;
            if (is_draft === '1' && state.planForm.begin_config === '1' && !state.planForm.begin_time) {
                begin_time = dayjs().format('YYYY-MM-DD HH:mm:00');
            } else {
                begin_time = state.planForm.begin_config === '1' ? dayjs(state.planForm.begin_time).format(
                    'YYYY-MM-DD HH:mm:00',
                ) : '';
            }
            const params: CreatePlanParams = {
                ...state.planForm,
                name: state.planForm.name,
                email_title: state.planForm.email_title,
                email_content: shtml(state.planForm.email_content),
                begin_config: state.planForm.begin_config,
                begin_time,
                timezone: state.planForm.timezone || '',
                sender_name: state.planForm.sender_name,
                email: state.planForm.email,
                template_content: state.planForm.template_content,
                template_id: state.planForm.template_id,
                is_draft,
            };
            if (params.begin_config === '0') {
                params.begin_time = '';
                params.timezone = '';
            }
            return createPlan(params);
        },
    },
};
